function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url-search-params.js";
import Slider from '../slider/slider';
import { getTmsInstance } from "integration-web-core--socle/js/assets/commons/_tms";

/**
 * Ajax Call to send products ids meshed and call to product thumbnails embedded fragment
 * @param {Array} productIds - product ids meshed
 * @param indexId the indexId
 */
function $fetchProductThumbnailHtml(productIds, indexId) {
  var queryString = "productIds=".concat(productIds.map(function (id) {
    return encodeURIComponent(id);
  }).join(','));
  fetch("/reload/components/product-thumbnails?".concat(queryString)).then(function (response) {
    if (!response.ok) {
      throw new Error('Error sending product IDs');
    }
    return response.text();
  }).then(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(shopTheLookContent) {
      var shopTheLookGallery;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            shopTheLookGallery = document.getElementById("div_STL" + indexId);
            if (shopTheLookGallery) {
              shopTheLookGallery.innerHTML = shopTheLookContent;
            } else {
              console.error('div_STL element not found');
            }
            // force the update of the TMS fragment to ensure the async data is correctly pushed
            _context.n = 1;
            return getTmsInstance().pushFragment([], false);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())["catch"](function (error) {
    return console.error(error.message);
  });
}

/**
 * @param {Image|HTMLImageElement|null} img
 */
function $setArrowPosition() {
  var img = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (window.innerWidth < 1024) {
    var imgBBox = (img || this.slider.currentSlide.node.querySelector('.o-media__image')).getBoundingClientRect();
    var navBBox = this.slider.controlsNav.getBoundingClientRect();
    this.slider.controlsNav.style.top = "".concat(imgBBox.height / 2 - navBBox.height / 2, "px");
  } else {
    this.slider.controlsNav.removeAttribute('style');
  }
}

/**
 * @param {Number|null} slideIndex
 */
function $createHistoryEntry() {
  var slideIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _document$URL$split = document.URL.split('?'),
    _document$URL$split2 = _slicedToArray(_document$URL$split, 1),
    url = _document$URL$split2[0];
  history.pushState({
    slideIndex: slideIndex
  }, document.title, "".concat(url).concat(slideIndex === null ? '' : "?slideIndex=".concat(slideIndex)));
}
function $reloadProductThumbnail() {
  var urlParams = new URLSearchParams(window.location.search);
  var slideIndex = urlParams.has('slideIndex') ? parseInt(urlParams.get('slideIndex'), 10) : null;
  if (slideIndex !== null) {
    var slideElement = document.querySelector(".o-stl__slide[data-uuid=STL".concat(slideIndex, "]"));
    if (slideElement) {
      var productIds = slideElement.getAttribute('data-product-ids').split(',');
      $fetchProductThumbnailHtml(productIds, slideIndex);
    } else {
      console.error('Slide element with class "o-stl__slide" not found');
    }
  } else {
    console.error('No slideIndex found in URL');
  }
}
var ShopTheLook = /*#__PURE__*/_createClass(
/**
 * @constructor
 * @param {HTMLElement} component
 */
function ShopTheLook(component) {
  var _this = this;
  _classCallCheck(this, ShopTheLook);
  this.galleryElement = document.getElementById('js-shop-the-look-gallery');
  $reloadProductThumbnail();
  if (this.galleryElement) {
    this.slider = new Slider({
      id: 'shop-the-look'
    });
    if (this.galleryElement.classList.contains('o-stl__gallery--visible')) {
      document.scrollingElement.style.overflow = 'hidden';
    }
    _toConsumableArray(component.querySelectorAll('.js-shop-the-look-open-button')).forEach(function (button) {
      button.addEventListener('click', function () {
        getTmsInstance().pushEvent(button,
        // target
        "cdl_event",
        // eventType
        {
          event_name: "popin.display",
          event_data: {
            popin_name: "shop the look v1",
            feature_name: "inspiration"
          }
        } // data
        );
        var slideIndex = parseInt(button.dataset.slide, 10);
        _this.galleryElement.classList.add('o-stl__gallery--visible');
        document.scrollingElement.style.overflow = 'hidden';
        _this.slider.translateTo(slideIndex, false);
        $setArrowPosition.call(_this);
        $createHistoryEntry(slideIndex);
        var slideElement = _this.slider.slideList[slideIndex].node.closest('.o-stl__slide');
        if (slideElement) {
          var productIds = slideElement.getAttribute('data-product-ids').split(',');
          $fetchProductThumbnailHtml(productIds, slideIndex);
        } else {
          console.error('Slide element with class "o-stl__slide" not found');
        }
      });
    });
    this.slider.root.addEventListener('slide', function (e) {
      $setArrowPosition.call(_this, e.detail.targetSlide.node.querySelector('.o-media__image'));
      $createHistoryEntry(e.detail.targetSlide.index);
      var slideElement = e.detail.targetSlide.node.closest('.o-stl__slide');
      if (slideElement) {
        var productIds = slideElement.getAttribute('data-product-ids').split(',');
        $fetchProductThumbnailHtml(productIds, e.detail.targetSlide.index);
      } else {
        console.error('Slide element with class "o-stl__slide" not found');
      }
    });
    this.galleryElement.querySelector('.js-close').addEventListener('click', function () {
      _this.galleryElement.classList.remove('o-stl__gallery--visible');
      document.scrollingElement.style.removeProperty('overflow');
      $createHistoryEntry(null);
    });
    var timer;
    window.addEventListener('resize', function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        $setArrowPosition.call(_this);
      }, 100);
    });

    // Listen for history change
    window.addEventListener('popstate', function (event) {
      if (event.state && ![undefined, null].includes(event.state.slideIndex)) {
        var slideIndex = event.state.slideIndex;
        if (!_this.galleryElement.classList.contains('o-stl__gallery--visible')) {
          document.scrollingElement.style.overflow = 'hidden';
          _this.galleryElement.classList.add('o-stl__gallery--visible');
        }
        _this.slider.translateTo(slideIndex, false);
      } else {
        _this.galleryElement.classList.remove('o-stl__gallery--visible');
        document.scrollingElement.style.removeProperty('overflow');
      }
    });
  }
});
export { ShopTheLook as default };